import styled from "styled-components"
import { useState } from 'react';
import theme from "../../styles/theme";

const MainWrap = styled.div`
    padding: 0.5rem 1rem;
    width: 100%;
    display: flex;
    align-items: center;

    > img {
        ${(props)=> props.status === true && 
            'transform: rotate(-0.5turn);'
        }
        transition: all 0.3s ease-in-out;
    }
    
`

const FoldingBar = ({onClick}) => {

    const [status, setStatus] = useState(false);

    const handleClick = () => {
        setStatus(!status);
        onClick && onClick(!status);
    }

    return (
        <MainWrap status={status} onClick={handleClick}>
            <div style={{height:1,background:theme.color.black[40],flexGrow:1}}/>
            <img src={`/images/ic_double_down_arrow.svg`} style={{height:'16px'}} />
            <div style={{height:1,background:theme.color.black[40],flexGrow:1}}/>
        </MainWrap>
    )
}

export default FoldingBar;